module.exports = __webpack_public_path__ + "img/apple-iphone-xs.902a7a12.png";